<template>
  <v-container class="margen_paginas pt-7" fluid>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="3" class="d-flex justify-center align-start">
        <v-card class="d-inline-block mr-3 mb-3" width="100%" max-width="380">
          <v-card-text class="pa-3">
            <h3 v-if="camara.url" class="mb-1">{{camara.des}}</h3>
            <VisorCamaraWebRTC :url="camara.url" :key="camara.url" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <TablaDatosAPI
          ref="tablaCamaras"
          :titulo="$t ('Cámaras')"
          icono="mdi-video-outline"
          tabla="cam"
          :campos="['id_ins', 'des+', 'url']"
          :campos-filtrables="['id_ins']"
          busqueda-rapida
          :titulo-crud="$t ('cámara')"
          permitir-anadir
          permitir-modificar
          permitir-eliminar
          :formulario-datos-api-props="{ anchoMaximo: '900' }"
          item-key="id_cam"
          single-select
          @seleccionModificada="actualizarCamaraSeleccionada"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import VisorCamaraWebRTC from "@/components/VisorCamaraWebRTC.vue";

export default {
  components: {
                TablaDatosAPI,
                VisorCamaraWebRTC
              },
  data() {
    return {
      camara: {},
    }
  },
  methods: {
    actualizarCamaraSeleccionada (registrosSeleccionados) {
      if (registrosSeleccionados.length == 0)
        this.camara = {};
      else
        this.camara = registrosSeleccionados[0];
    }
  }
};
</script>

<style>
</style>